import React from 'react';
import { connect } from 'react-redux';

import AppleLogin from 'react-apple-login';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { GetRegion } from 'constants.js';
import PanelClaro from '../forms/PanelClaro';
import FbAccountAttach from './socialNetwork/FbAccountAttach';
import FbAccountRemove from './socialNetwork/FbAccountRemove';
import AppleRemove from './socialNetwork/AppleRemove';
import * as actions from '../../actions/response';
import RequestManager from '../../requests/RequestManager';
import AddSocialRelationTask from '../../requests/tasks/user/AddSocialRelationTask';
import DeleteSocialRelationTask from '../../requests/tasks/user/DeleteSocialRelationTask';
import { converter } from '../../helpers/converter';

const SOCIAL_NETWORK = 'facebook';

export class SocialSection extends React.Component {
  constructor() {
    super();
    this.state = {
      facebookData: {},
      isAttached: false,
      userFetch: false,
      appleAttached: false,
    };
  }
  // TODO: REFACTOR -> Replace componentWillReceiveProps with componentDidUpdate

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.user &&
      nextProps.user !== this.props.user &&
      nextProps.user.info &&
      !this.state.userFetch
    ) {
      if (nextProps.user.info.socialdata != null)
        this.setState({
          facebookData: nextProps.user.info.socialdata,
          isAttached: true,
          userFetch: true,
        });

      if (
        nextProps.user.info.socialNetworks != null &&
        nextProps.user.info.socialNetworks.length > 0 &&
        _.find(nextProps.user.info.socialNetworks, { redsocial: 'APPLE' })
      )
        this.setState({
          appleAttached: true,
        });
    }
  }

  onSuccess(data) {
    // TODO: REFACTOR -> No realizar atualización de parametros,
    // eslint-disable-next-line no-param-reassign
    data.message = data.message || 'Suscripción cancelada';
  }

  onFailed(data) {
    // TODO: REFACTOR -> No realizar atualización de parametros,
    // eslint-disable-next-line no-param-reassign
    data.message = data.message || 'Error';
  }

  addSocialRelation() {
    const params = {
      usersocial_id: this.state.facebookData.id,
      socialnetwork: SOCIAL_NETWORK,
      user_hash: this.props.user.userhash,
      user_id: this.props.user.user_id,
    };

    const fbData = JSON.stringify(this.state.facebookData);

    const request = new AddSocialRelationTask(
      this.props.config,
      params,
      fbData,
    );
    RequestManager.addRequest(request)
      .then(this.onSuccess.bind(this))
      .catch(this.onFailed.bind(this));
  }

  onAttachFacebook = response => {
    if (typeof response.id === 'undefined') {
      const modal = {
        modalType: 'ErrorSimple',
        props: {
          message: converter.convertApaUnicode(
            this.props.translations,
            'profile_social_fb_error_attach',
            'No has podido ingresar con tu usuario de Facebook, debes aceptar los permisos.',
          ),
        },
      };

      this.props.showModal(modal);
      return;
    }

    this.setState({
      isAttached: true,
      facebookData: {
        id: response.id,
        name: response.name,
        image: response.picture.data.url,
      },
    });

    this.addSocialRelation();
  };

  onDetachedApple = () => {
    const params = {};
    params.socialnetwork = 'APPLE';
    params.user_hash = this.props.user.userhash;

    const request = new DeleteSocialRelationTask(this.props.config, params);
    RequestManager.addRequest(request)
      .then(() =>
        this.setState({
          appleAttached: false,
        }),
      )
      .catch(() => console.log('error apple deattached'));
  };

  onDetachedFacebook = () => {
    this.setState({
      isAttached: false,
      facebookData: {},
    });

    const params = {
      socialnetwork: SOCIAL_NETWORK,
      user_hash: this.props.user.userhash,
    };

    const request = new DeleteSocialRelationTask(this.props.config, params);
    RequestManager.addRequest(request)
      .then(this.onSuccess.bind(this))
      .catch(this.onFailed.bind(this));
  };

  render() {
    const socialAppleConfig = window.utils.getMeta.metadata(
      'user_socialoptions_config',
    ).enable_user_addsocialrelation_apple;
    const appleEnable = _.get(
      socialAppleConfig,
      [GetRegion()],
      _.get(socialAppleConfig, ['default'], { enabled: false }),
    );

    const content = (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h3 className="micuenta-title">
                <strong>
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'profile_social_network_title',
                    'Redes Sociales',
                  )}
                </strong>
              </h3>
            </div>
          </div>
        </div>
        <div className="row">
          {appleEnable.enabled && (
            <div className="appleBtnContainer col-xs-12 col-sm-4 col-md-2 col-lg-2 col-xs-offset-0 col-sm-offset-8 col-md-offset-10 col-lg-offset-10 padding-top-1">
              {!this.state.appleAttached ? (
                <AppleLogin
                  clientId="www.clarovideo.com"
                  redirectURI="https://www.clarovideo.com/loginapplecallback"
                  responseType="code id_token"
                  scope="name email"
                  responseMode="form_post"
                  designProp={{
                    color: 'white',
                    width: 150,
                    locale: 'es_MX',
                  }}
                />
              ) : (
                <AppleRemove removeApple={this.onDetachedApple} />
              )}
            </div>
          )}
        </div>
        {this.state.isAttached ? (
          <FbAccountRemove
            facebookData={this.state.facebookData}
            onDetachedFacebook={this.onDetachedFacebook.bind(this)}
          />
        ) : (
          <FbAccountAttach
            onAttachFacebook={this.onAttachFacebook.bind(this)}
          />
        )}
      </div>
    );

    return <PanelClaro children={content} />;
  }
}

SocialSection.propTypes = {
  config: PropTypes.shape({}),
  translations: PropTypes.shape({}),
  showModal: PropTypes.func,
  user: PropTypes.shape({
    userhash: PropTypes.string,
    user_id: PropTypes.string,
    info: PropTypes.shape({
      socialdata: PropTypes.shape({}),
    }),
  }),
};

const mapStateToProps = state => ({
  translations: state.translations,
  config: state.config,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SocialSection);
